import type { UserAvatarCreateData } from "@shared/data/mutations/UserAvatarCreateMutation/UserAvatarCreate.mutation";
import { useUserAvatarCreateMutation } from "@shared/data/mutations/UserAvatarCreateMutation/UserAvatarCreate.mutation";
import type { UserAvatarDeleteData } from "@shared/data/mutations/UserAvatarDeleteMutation/UserAvatarDelete.mutation";
import { useUserAvatarDeleteMutation } from "@shared/data/mutations/UserAvatarDeleteMutation/UserAvatarDelete.mutation";
import type { UserProfileQueryData } from "@shared/data/queries/UserProfileQuery/UserProfile.query";
import { useUserProfileQuery } from "@shared/data/queries/UserProfileQuery/UserProfile.query";
import { AvatarSize } from "@shared/types/avatarSize";

const useAvatarHooks = (
  createOnComplete: (data: UserAvatarCreateData) => void,
  deleteOnComplete: (data: UserAvatarDeleteData) => void,
  onQueryComplete: (data: UserProfileQueryData) => void,
  onError: ({ fields, message }: { fields: object; message: string }) => void,
  errors: { fields: object }
) => {
  const { loading: userProfileLoading } = useUserProfileQuery({
    variables: {
      filter: AvatarSize.LARGE,
    },
    onCompleted: onQueryComplete,
  });

  const [userAvatarCreate, { loading: avatarCreateLoading }] = useUserAvatarCreateMutation({
    onCompleted: data => createOnComplete(data),
    onError: ({ message }) => onError({ ...errors, message }),
  });

  const [userAvatarDelete, { loading: avatarDeleteLoading }] = useUserAvatarDeleteMutation({
    onCompleted: data => deleteOnComplete(data),
    onError: ({ message }) => onError({ ...errors, message }),
  });

  return {
    userAvatarCreate,
    userAvatarDelete,
    loading: { userProfileLoading, avatarCreateLoading, avatarDeleteLoading },
  };
};

export { useAvatarHooks };
